import { useEffect, useState } from "react";

const Collapsible = ({
  isOpen,
  label,
  children,
  top,
  showAngle,
  openedLabel,
  ...rest
}) => {
  const [show, setShow] = useState(isOpen || false);

  const toggleShow = () => setShow(!show);

  useEffect(() => {
    setShow(isOpen);
  }, [isOpen]);

  return (
    <div className={`collapsible-component`} {...rest}>
      {top && (
        <div className={`content-parent${show ? ` show` : ``}`}>
          <div className="content">{children}</div>
        </div>
      )}
      {label && (
        <div className="d-flex clickable" onClick={toggleShow}>
          <a className="toggle me-2">
            {show && openedLabel ? openedLabel : label}
          </a>
          <i
            className={`${
              showAngle ? `far fa-angle-${show ? `up` : `down`}` : ``
            }  fs-4 text-primary`}
          ></i>
        </div>
      )}
      {!top && (
        <div className={`content-parent ${show ? `show` : ``}`}>
          <div className={`content`}>{children}</div>
        </div>
      )}
    </div>
  );
};

export default Collapsible;
